// extracted by mini-css-extract-plugin
export default {"container":"CHCSyZ","divider":"DTWmOc"};